var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.125V18.75H26.25V3.125M18.75 23.125L15 26.875L11.25 23.125M15 18.75V26.875",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.125C17.5313 13.125 19.8231 11.875 21.875 9.375C19.8231 6.875 17.5313 5.625 15 5.625C12.4687 5.625 10.1769 6.875 8.125 9.375C10.1769 11.875 12.4687 13.125 15 13.125Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25C15.4973 11.25 15.9742 11.0525 16.3258 10.7008C16.6775 10.3492 16.875 9.87228 16.875 9.375C16.875 8.87772 16.6775 8.40081 16.3258 8.04917C15.9742 7.69754 15.4973 7.5 15 7.5C14.5027 7.5 14.0258 7.69754 13.6742 8.04917C13.3225 8.40081 13.125 8.87772 13.125 9.375C13.125 9.87228 13.3225 10.3492 13.6742 10.7008C14.0258 11.0525 14.5027 11.25 15 11.25Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewJob);
export default __webpack_public_path__ + "static/media/view_job.2ceea1bfb0a27ca0a9aba55b48d3430a.svg";
export { ForwardRef as ReactComponent };